import Fuse from 'fuse.js';

import { type EmojiDef, emojis } from './emojis';

const fuse = new Fuse(emojis, {
    shouldSort: true,
    threshold: 0.4,
    distance: 100,
    keys: [
        {
            name: 'name',
            weight: 0.7,
        },
        {
            name: 'keywords',
            weight: 0.3,
        },
    ],
});

/**
 * Search emojis by a text.
 */
export function searchEmojis(query: string): EmojiDef[] {
    return fuse.search(query).map((x) => x.item);
}
